<template>
  <v-container
    class="my-6"
  >
    <v-row
      align="start"
      justify="center"
      class="text-center mb-1"
    >
      <v-col>
        <v-icon x-large>
          supervisor_account
        </v-icon>
        <h2 class="display-2">
          Deine Mannschaft
        </h2>
      </v-col>
    </v-row>

    <v-row class="my-6 d-none d-sm-flex">
      <v-col class="text-center">
        <v-btn-toggle
          v-model="toggleActive"
          rounded
          background-color="primary darken-1"
          dark
        >
          <v-btn to="/mannschaft">
            Übersicht
          </v-btn>
          <v-btn to="/aufstellung">
            Aufstellung
          </v-btn>
          <v-btn>
            Training / Trainingslager
          </v-btn>
          <v-btn to="/vertrag">
            Verträge
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-row
      align="start"
      justify="center"
      class="text-center mb-1"
    >
      <v-col cols="12" class="display-2">
        Training / Trainingslager
      </v-col>
      <v-col cols="12" class="body-1">
        <b>nächtes Spiel:</b> {{ $store.state.office.nextGame.text }}
      </v-col>
    </v-row>

    <page-loading :is-page-loading="$store.state.pageLoading" />

    <v-row
      justify="center"
      align="center"
      class="my-6"
    >
      <v-col
        cols="10"
        sm="10"
      >
        <v-tabs
          v-model="activeTab"
          background-color="primary"
          class="elevation-2"
          dark
          centered
          grow
        >
          <v-tabs-slider color="pink" />
          <v-tab :key="1" ripple>
            Training
          </v-tab>
          <v-tab :key="2" ripple>
            Trainingslager
          </v-tab>

          <v-tab-item :key="1">
            <v-card flat>
              <v-card-text class="text-center">
                <v-row>
                  <v-col>
                    <p class="body-1">
                      Trainiert wird die ganze Mannschaft.<br>
                      Durch deinen gewählten Sponsor, stehen dir <b>{{ $store.state.moneyStore.sponsor.tp }} Trainings-Punkte</b> zur Verfügung.
                    </p>
                  </v-col>
                </v-row>

                <v-row
                  justify="center"
                >
                  <v-col
                    cols="3"
                    class="text-left flex-grow-0"
                  >
                    <span class="body-1">Heimindex:</span>
                    <br>
                    Team ∅ =  {{ avgHeimindex }} Kegel
                  </v-col>
                  <v-col>
                    <v-slider
                      v-model="trainingHeimindex"
                      :max="tpMaxSum"
                      :change="testTP('Heimindex')"
                      thumb-label
                      step="1"
                      min="0"
                      ticks
                    />
                  </v-col>
                  <v-col cols="2">
                    <span class="title">{{ trainingHeimindex || 0 }}  TP</span>
                  </v-col>
                </v-row>

                <v-row
                  justify="center"
                >
                  <v-col
                    cols="3"
                    class="text-left flex-grow-0"
                  >
                    <span class="body-1">Auswindex:</span>
                    <br>
                    Team ∅ = {{ avgAuswindex }} Kegel
                  </v-col>
                  <v-col>
                    <v-slider
                      v-model="trainingAuswindex"
                      :max="tpMaxSum"
                      :change="testTP('Auswindex')"
                      thumb-label
                      step="1"
                      min="0"
                      ticks
                    />
                  </v-col>
                  <v-col cols="2">
                    <span class="title">{{ trainingAuswindex || 0 }} TP</span>
                  </v-col>
                </v-row>

                <v-row
                  justify="center"
                >
                  <v-col
                    cols="3"
                    class="text-left flex-grow-0"
                  >
                    <span class="body-1">Kraft:</span>
                    <br>
                    Team ∅ = {{ avgKraft }}
                  </v-col>
                  <v-col>
                    <v-slider
                      v-model="trainingKraft"
                      :max="tpMaxSum"
                      :change="testTP('Kraft')"
                      thumb-label
                      step="1"
                      min="0"
                      ticks
                    />
                  </v-col>
                  <v-col cols="2">
                    <span class="title">{{ trainingKraft || 0 }} TP</span>
                  </v-col>
                </v-row>

                <v-row
                  justify="center"
                >
                  <v-col
                    cols="3"
                    class="text-left flex-grow-0"
                  >
                    <span class="body-1">Kondition:</span>
                    <br>
                    Team ∅ = {{ avgKondition }}
                  </v-col>
                  <v-col>
                    <v-slider
                      v-model="trainingKondition"
                      :max="tpMaxSum"
                      :change="testTP('Kondition')"
                      thumb-label
                      step="1"
                      min="0"
                      ticks
                    />
                  </v-col>
                  <v-col cols="2">
                    <span class="title">{{ trainingKondition || 0 }} TP</span>
                  </v-col>
                </v-row>

                <v-row
                  justify="center"
                >
                  <v-col
                    cols="3"
                    class="text-left flex-grow-0"
                  >
                    <span class="body-1">Motivation:</span>
                    <br>
                    Team ∅ = {{ avgMotivation }}
                  </v-col>
                  <v-col>
                    <v-slider
                      v-model="trainingMotivation"
                      :max="tpMaxSum"
                      :change="testTP('Motivation')"
                      thumb-label
                      step="1"
                      min="0"
                      ticks
                    />
                  </v-col>
                  <v-col cols="2">
                    <span class="title">{{ trainingMotivation || 0 }} TP</span>
                  </v-col>
                </v-row>

                <v-row
                  justify="center"
                >
                  <v-col
                    cols="3"
                    class="text-left flex-grow-0"
                  >
                    <span class="body-1">Technik:</span>
                    <br>
                    Team ∅ = {{ avgTechnik }}
                  </v-col>
                  <v-col>
                    <v-slider
                      v-model="trainingTechnik"
                      :max="tpMaxSum"
                      :change="testTP('Technik')"
                      thumb-label
                      step="1"
                      min="0"
                      ticks
                    />
                  </v-col>
                  <v-col cols="2">
                    <span class="title">{{ trainingTechnik || 0 }} TP</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <p class="text-center body-1">
                      Vergebene Trainings-Punkte: <b>{{ getSum() || 0 }} TP</b> / {{ $store.state.moneyStore.sponsor.tp }} TP
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  :loading="$store.state.loading"
                  :disabled="$store.state.loading"
                  color="primary"
                  class="mx-auto mb-4"
                  @click.native="saveTraining"
                >
                  Training speichern
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>

          <v-tab-item :key="2">
            <v-card flat>
              <v-card-text>
                <v-row>
                  <v-col>
                    <p class="text-center body-1">
                      Im Trainingslager erhalten alle Spieler die angezeigten Werte.<br>
                      Der Zufallsgenerator ist hier ausgeschaltet.
                    </p>
                  </v-col>
                </v-row>

                <v-row
                  v-if="selectedTrainingslager === false"
                  justify="center"
                >
                  <v-col
                    v-for="(item, index) in trainingslagers"
                    :key="'trainingslagerdiv' + index"
                  >
                    <v-card
                      color="grey lighten-4"
                    >
                      <v-responsive>
                        <v-img
                          :src="$store.state.teamStore.imageURL + item.nr + '.png'"
                          height="150px"
                          class="cover"
                        />
                      </v-responsive>

                      <v-card-title primary-title>
                        <h3 class="title my-2">
                          {{ item.name }}
                        </h3>
                      </v-card-title>
                      <v-card-text>
                        <p class="body-2">
                          {{ item.text }}
                        </p>
                        <v-divider />
                        <h3 class="title my-4">
                          Trainingswerte:
                        </h3>
                        <v-row
                          justify="center"
                        >
                          <v-col
                            cols="6"
                            class="text-center"
                          >
                            <h5>Heimindex</h5>
                            <v-progress-circular
                              :value="item.heimIndex"
                              color="teal"
                            >
                              {{ item.heimIndex }}
                            </v-progress-circular>
                          </v-col>
                          <v-col
                            cols="6"
                            class="text-center"
                          >
                            <h5>Auswindex</h5>
                            <v-progress-circular
                              :value="item.auswIndex"
                              color="teal"
                            >
                              {{ item.auswIndex }}
                            </v-progress-circular>
                          </v-col>

                          <v-col
                            class="text-center"
                          >
                            <h5>Kraft</h5>
                            <v-progress-circular
                              :value="item.kraft"
                              color="teal"
                            >
                              {{ item.kraft }}
                            </v-progress-circular>
                          </v-col>
                          <v-col
                            class="text-center"
                          >
                            <h5>Technik</h5>
                            <v-progress-circular
                              :value="item.technik"
                              color="blue"
                            >
                              {{ item.technik }}
                            </v-progress-circular>
                          </v-col>
                          <v-col
                            class="text-center"
                          >
                            <h5>Kondition</h5>
                            <v-progress-circular
                              :value="item.kondition"
                              color="blue"
                            >
                              {{ item.kondition }}
                            </v-progress-circular>
                          </v-col>
                          <v-col
                            class="text-center"
                          >
                            <h5>Motivation</h5>
                            <v-progress-circular
                              :value="item.motivation"
                              color="blue"
                            >
                              {{ item.motivation }}
                            </v-progress-circular>
                          </v-col>
                        </v-row>

                        <v-divider class="my-4" />
                        <v-row
                          justify="center"
                          class="text-center"
                        >
                          <v-col
                            v-if="$store.state.moneyStore.giro > item.kosten"
                          >
                            <h4 class="mb-4 text-center">
                              Kosten des Trainingslagers: {{ item.kosten | currency }}
                            </h4>

                            <v-btn
                              :loading="$store.state.loading"
                              :disabled="$store.state.loading"
                              color="primary"
                              @click.native="bookTrainingslager(item._id)"
                            >
                              Trainingslager buchen
                              <v-icon right dark>
                                mdi-cash-100
                              </v-icon>
                            </v-btn>
                          </v-col>
                          <v-col
                            v-else
                            class="body-2"
                          >
                            Du hast nicht genug Geld auf deinem Konto, um Dir dieses Trainingslager zu buchen
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row
                  v-else
                  justify="center"
                >
                  <v-col>
                    <v-card
                      raised
                      color="primary"
                    >
                      <v-card-title primary-title>
                        <h3 class="headline mb-0 white--text">
                          Dein gewähltes Trainingslager
                        </h3>
                      </v-card-title>

                      <v-row>
                        <v-card
                          color="grey lighten-4"
                        >
                          <v-responsive>
                            <v-img
                              :src="$store.state.teamStore.imageURL + selectedTrainingslager.nr + '.png'"
                              height="250px"
                              class="cover"
                            />
                          </v-responsive>

                          <v-card-title primary-title>
                            <h3 class="headline">
                              {{ selectedTrainingslager.name }}
                            </h3>
                            <div class="subtitle-1">
                              {{ selectedTrainingslager.text }}
                            </div>
                          </v-card-title>
                          <v-card-text>
                            <h3 class="title mb-4">
                              Trainingswerte:
                            </h3>
                            <v-row
                              justify="center"
                            >
                              <v-col
                                cols="6"
                                class="text-center"
                              >
                                <h4>Heimindex</h4>
                                <v-progress-circular
                                  :value="selectedTrainingslager.heimIndex"
                                  color="teal"
                                  size="48"
                                >
                                  <b>{{ selectedTrainingslager.heimIndex }}</b>
                                </v-progress-circular>
                              </v-col>
                              <v-col
                                cols="6"
                                class="text-center"
                              >
                                <h4>Auswindex</h4>
                                <v-progress-circular
                                  :value="selectedTrainingslager.auswIndex"
                                  color="teal"
                                  size="48"
                                >
                                  <b>{{ selectedTrainingslager.auswIndex }}</b>
                                </v-progress-circular>
                              </v-col>

                              <v-col
                                class="text-center"
                              >
                                <h4>Kraft</h4>
                                <v-progress-circular
                                  :value="selectedTrainingslager.kraft"
                                  color="teal"
                                  size="48"
                                >
                                  <b>{{ selectedTrainingslager.kraft }}</b>
                                </v-progress-circular>
                              </v-col>
                              <v-col
                                class="text-center"
                              >
                                <h4>Technik</h4>
                                <v-progress-circular
                                  :value="selectedTrainingslager.technik"
                                  color="blue"
                                  size="48"
                                >
                                  <b>{{ selectedTrainingslager.technik }}</b>
                                </v-progress-circular>
                              </v-col>
                              <v-col
                                class="text-center"
                              >
                                <h4>Kondition</h4>
                                <v-progress-circular
                                  :value="selectedTrainingslager.kondition"
                                  color="blue"
                                  size="48"
                                >
                                  <b>{{ selectedTrainingslager.kondition }}</b>
                                </v-progress-circular>
                              </v-col>
                              <v-col
                                xs3
                                class="text-center"
                              >
                                <h4>Motivation</h4>
                                <v-progress-circular
                                  :value="selectedTrainingslager.motivation"
                                  color="blue"
                                  size="48"
                                >
                                  <b>{{ selectedTrainingslager.motivation }}</b>
                                </v-progress-circular>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'Training',
  metaInfo: {
    title: 'Mannschaft - Training'
  },
  data () {
    return {
      toggleActive: 2,
      activeTab: null,
      trainingKraft: 0,
      trainingMotivation: 0,
      trainingTechnik: 0,
      trainingKondition: 0,
      trainingHeimindex: 0,
      trainingAuswindex: 0,
      avgKraft: 0,
      avgMotivation: 0,
      avgTechnik: 0,
      avgKondition: 0,
      avgHeimindex: 0,
      avgAuswindex: 0,
      tpSum: 0,
      tpMaxSum: 0,
      trainingslagers: {},
      selectedTrainingslager: false
    }
  },
  mounted: async function () {
    this.tpMaxSum = this.$store.state.moneyStore.sponsor.tp
    try {
      /*
      Berechne die Durchschnitte der Mannschaftswerte
      https://codereview.stackexchange.com/questions/141530/calculate-average-of-array-of-objects-per-key-value-using-reduce
      */
      var playerData = this.$store.state.teamStore.players
      var avg = Array.from(playerData.reduce(
        (acc, obj) => Object.keys(obj).reduce(
          (acc, key) => typeof obj[key] === 'number'
            ? acc.set(key, (acc.get(key) || []).concat(obj[key]))
            : acc,
          acc),
        new Map())).reduce(
        (acc, [name, values]) =>
          Object.assign(acc, { [name]: Math.round(values.reduce((a, b) => a + b) / values.length) }),
        {}
      )
      this.avgKraft = avg.kraft
      this.avgMotivation = avg.motivation
      this.avgTechnik = avg.technik
      this.avgKondition = avg.kondition
      this.avgHeimindex = avg.heimIndex
      this.avgAuswindex = avg.auswIndex

      // lade trainingsdata
      if (await this.$store.dispatch('teamStore/loadTraining')) {
        if (this.$store.state.teamStore.trainingsLagers) {
          this.trainingslagers = this.$store.state.teamStore.trainingsLagers
        }
        if (this.$store.state.teamStore.training) {
          this.trainingKraft = this.$store.state.teamStore.training.kraft || 0
          this.trainingMotivation = this.$store.state.teamStore.training.motivation || 0
          this.trainingTechnik = this.$store.state.teamStore.training.technik || 0
          this.trainingKondition = this.$store.state.teamStore.training.kondition || 0
          this.trainingHeimindex = this.$store.state.teamStore.training.heimIndex || 0
          this.trainingAuswindex = this.$store.state.teamStore.training.auswIndex || 0
        }

        if (this.$store.state.teamStore.selectedTrainingslager) {
          this.selectedTrainingslager = this.$store.state.teamStore.selectedTrainingslager
        }
      }
    } catch (error) {
      this.trainingKraft = 0
      this.trainingMotivation = 0
      this.trainingTechnik = 0
      this.trainingKondition = 0
      this.trainingHeimindex = 0
      this.trainingAuswindex = 0
      this.selectedTrainingslager = false
    }
  },
  methods: {
    getSum: function () {
      const sum = this.trainingTechnik + this.trainingKondition + this.trainingHeimindex + this.trainingAuswindex + this.trainingKraft + this.trainingMotivation
      return sum || 0
    },
    testTP: async function (val) {
      const max = this.tpMaxSum
      const current = await this.getSum()

      if (current > max) {
        switch (val) {
          case 'Heimindex':
            if (this.trainingHeimindex > 0) {
              this.trainingHeimindex = this.trainingHeimindex - 1
            }
            break
          case 'Auswindex':
            if (this.trainingAuswindex > 0) {
              this.trainingAuswindex = this.trainingAuswindex - 1
            }
            break
          case 'Technik':
            if (this.trainingTechnik > 0) {
              this.trainingTechnik = this.trainingTechnik - 1
            }
            break
          case 'Kondition':
            if (this.trainingKondition > 0) {
              this.trainingKondition = this.trainingKondition - 1
            }
            break
          case 'Motivation':
            if (this.trainingMotivation > 0) {
              this.trainingMotivation = this.trainingMotivation - 1
            }
            break
          case 'Kraft':
            if (this.trainingKraft > 0) {
              this.trainingKraft = this.trainingKraft - 1
            }
            break
          default:
        }
      }
    },
    saveTraining: async function () {
      // save training with store component
      await this.$store.dispatch('teamStore/saveTraining', {
        kraft: this.trainingKraft,
        motivation: this.trainingMotivation,
        technik: this.trainingTechnik,
        kondition: this.trainingKondition,
        heimindex: this.trainingHeimindex,
        auswindex: this.trainingAuswindex
      })
    },
    bookTrainingslager: async function (id) {
      // save training with store component
      if (await this.$store.dispatch('teamStore/saveTrainingslager', id)) {
        this.selectedTrainingslager = this.$store.state.teamStore.selectedTrainingslager
      }
    }
  }
}
</script>
<style>
.input-group--slider label {
  width: 135px !important;
  text-align: right !important;
  display: inline-block !important;
}
.input-group__details {
  display: inline-block !important;
  text-align: right !important;
}
.cover {
  background-size: cover;
}

</style>
